import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f54b9e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "check-amazon-goods-modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/icon/fba/check_icon.png",
    alt: "",
    class: "center-img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/icon/fba/loading2.png",
    alt: "",
    class: "top-img"
  })
], -1))
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { style: {"width":"40px","display":"inline-block","text-align":"left"} }
const _hoisted_5 = { class: "progress-content" }
const _hoisted_6 = { class: "progress" }
const _hoisted_7 = { class: "num" }
const _hoisted_8 = { class: "tip" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/icon/fba/error_icon.png",
    alt: "",
    class: "success-img"
  })
], -1))
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "tip" }
const _hoisted_12 = {
  key: 2,
  class: "table-content"
}
const _hoisted_13 = { style: {"max-width":"200px"} }
const _hoisted_14 = { class: "line--2" }
const _hoisted_15 = {
  key: 0,
  class: "error-result"
}
const _hoisted_16 = { class: "error-icon flex-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/fba/fail_icon.png",
  alt: ""
}, null, -1))
const _hoisted_18 = { class: "error-res" }
const _hoisted_19 = {
  key: 1,
  class: "error-result success"
}
const _hoisted_20 = { class: "error-icon flex-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/fba/success_icon2.png",
  alt: ""
}, null, -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = {
  key: 3,
  class: "btn-content"
}
const _hoisted_27 = { class: "check-amazon-goods-modal" }
const _hoisted_28 = {
  key: 0,
  class: "loading-icon"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/fba/loading1.png",
  alt: "",
  class: "center-img"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/fba/loading2.png",
  alt: "",
  class: "top-img"
}, null, -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "loading-icon"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/fba/success_icon.png",
  alt: "",
  class: "success-img"
}, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 2,
  class: "title"
}
const _hoisted_36 = { style: {"width":"40px","display":"inline-block","text-align":"left"} }
const _hoisted_37 = {
  key: 3,
  class: "title"
}
const _hoisted_38 = {
  key: 4,
  class: "tip",
  style: {"padding-bottom":"50px"}
}
const _hoisted_39 = {
  key: 5,
  class: "modal-footer"
}

import { ElMessage } from 'element-plus'
import STable from '@/components/Table/index.vue'
import { t } from '@/plugins/i18n'
import { checkAmazonGoodsApi, updateAmazonProductApi } from '@/apis/goods'
import { ref, onMounted, onUnmounted } from 'vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { errorMap } from '../data'
import { labelMap } from '@/views/authorized/SyncProduct/data'
import { useRouter } from 'vue-router'
import { useRtfix } from '@/store'
import { useStore } from 'vuex'
import {
  amazonGet
} from '@/apis/inShipping'

export default /*#__PURE__*/_defineComponent({
  props: ['list', 'submit', 'prepCategoryList'],
  emits: ['update', 'del'],
  setup(__props, { expose, emit: emits }) {

const props = __props
const router = useRouter()


const isLoading = ref(true)
const visible = ref(false)
const createVisible = ref(false)
const checkFinish = ref(false)
const store = useStore()
const columns: any = [
  {
    label: t('THE CKB sku'),
    prop: 'productSku',
    align: 'center'
  },
  {
    label: t('Amazon商品名'),
    prop: 'amazonProductTitle',
    align: 'center',
    slotName: 'amazonProductTitle'
  },
  {
    label: t('Amazon sku'),
    prop: 'amazonMsku',
    align: 'center'
  },
  {
    label: t('预处理分类'),
    prop: 'prepCategory',
    align: 'center',
    slotName: 'prepCategory'
  },
  {
    label: t('预处理方'),
    prop: 'prepOwnerConstraint',
    align: 'center',
    slotName: 'prepOwnerConstraint'
  },
  {
    label: t('贴标方'),
    prop: 'labelOwnerConstraint',
    align: 'center',
    slotName: 'labelOwnerConstraint'
  },
  {
    label: t('Amazon校验结果'),
    prop: 'errorCode',
    align: 'center',
    slotName: 'errorCode'
  },
  {
    label: t('建议处理方案'),
    prop: 'handleOption',
    align: 'center',
    slotName: 'handleOption'
  }
]
// 失败商品列表
const tableData: any = ref([])
// 通过商品列表
const passData: any = ref([])
// 是否创建成功
const createSuccess = ref(false)
const open = async (errorList?: any) => {
  visible.value = true
  createSuccess.value = false
  checkFinish.value = false
  tableData.value = []
  passData.value = []

  if (errorList) {
    // 报错二次弹起
    props.list.forEach((item: any) => {
      const errorItem = errorList.find((v: any) => v.msku === item.amazonMsku)
      if (errorItem) {
        tableData.value.push({ ...item, errorCode: errorItem.errorType })
      } else {
        passData.value.push(item)
      }
    })
    checkFinish.value = true
    return
  }
  for (let i = 0; i < props.list.length; i++) {
    const data = await check(props.list[i])
    console.log('datadata', data)
    // check sku  0 ok  1失效  2 未设置  3 预处理方或者方不一致
    if (data === 0) {
      passData.value.push(props.list[i])
    } else {
      tableData.value.push({
        ...props.list[i],
        errorCode: data
      })
    }
  }
  checkPassSubmit()
  checkFinish.value = true
}
expose({
  open,
  createVisible,
  createSuccess
})
onMounted(() => {
  loadingAnimation()
})
onUnmounted(() => {
  isLoading.value = false
  clearTimeout(timer)
})
const loadingText = ref('...')
let timer: any = null
const loadingAnimation = () => {
  if (!isLoading.value) {
    clearTimeout(timer)
    return
  }
  loadingText.value = loadingText.value === '...' ? '.' : loadingText.value === '..' ? '...' : '..'
  timer = setTimeout(() => {
    loadingAnimation()
  }, 800)
}

const close = () => {
  visible.value = false
}
const againCheck = async () => {
  checkFinish.value = false
  const list = [...tableData.value]
  tableData.value = []
  for (let i = 0; i < list.length; i++) {
    const data = await check(list[i])
    if (data === 0) {
      passData.value.push(list[i])
    } else {
      tableData.value.push({
        ...list[i],
        errorCode: data
      })
    }
  }
  checkFinish.value = true
  checkPassSubmit()
}
// 校验商品
const check = async (item: { amazonMsku: string }) => {
  const { data } = await checkAmazonGoodsApi({
    msku: item.amazonMsku
  })
  emits('update', { ...item, errorCode: data })
  await new Promise((resolve) => setTimeout(resolve, 300))
  return data
}

const checkPassSubmit = async () => {
  if (tableData.value.length) return
  visible.value = false
  createVisible.value = true
  const data = await props.submit()
  if (data) {
    // props.submit()成功后有轮询，并未成功
    return
  }
  createVisible.value = false
}
const closeModal = () => {
  createVisible.value = false
  location.reload()
}
// 删除商品
const delGoods = (row) => {
  tableData.value = tableData.value.filter(v => v.productSku !== row.productSku)
  emits('del', row)
  if (props.list.filter(v => v.productSku !== row.productSku).length === 0) {
    visible.value = false
  }
}
const updateLoading = ref(false)
const updateGoods = async (row:{amazonMsku:string, updateLoading?:boolean}) => {
  if (updateLoading.value || row.updateLoading) return
  updateLoading.value = true
  row.updateLoading = true
  const { success } = await updateAmazonProductApi({
    amazonMsku: row.amazonMsku
  })
  if (success) {
    ElMessage.success(t('更新成功'))
  }
  row.updateLoading = false
  amazonGet({
    amazonSkuList: [row.amazonMsku],
    customerShopId: store.getters.curShop
  }).then((res) => {
    const amazonItem = res.data?.[0]
    if (amazonItem) {
      tableData.value.forEach((item:any) => {
        if (item.amazonMsku === row.amazonMsku) {
          item.labelOwnerConstraint = amazonItem.labelOwnerConstraint
          item.prepCategory = amazonItem.prepCategory
          item.prepOwnerConstraint = amazonItem.prepOwnerConstraint
        }
      })
      emits('update', {
        ...row,
        labelOwnerConstraint: amazonItem.labelOwnerConstraint,
        prepCategory: amazonItem.prepCategory,
        prepOwnerConstraint: amazonItem.prepOwnerConstraint
      })
    }
  })
  await new Promise((resolve) => setTimeout(resolve, 3000))
  updateLoading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CommonDialog, {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      title: _unref(t)('创建发货单'),
      width: 900,
      onCancel: close,
      closeOnClickModal: false,
      hiddenClose: !checkFinish.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (!checkFinish.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                  _createTextVNode(_toDisplayString(_unref(t)('正在校验Amazon商品信息中，请勿退出')) + " ", 1),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(loadingText.value), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: "progress-now",
                      style: _normalizeStyle({ width: (passData.value.length + tableData.value.length) / __props.list.length * 100 + '%' })
                    }, null, 4)
                  ]),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(passData.value.length) + " / " + _toDisplayString(__props.list.length), 1)
                ]),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('根据Amazon的最新规定，建发货时需要维护好每个商品上的预处理分类、预处理方和贴标方，请及时去amazon后台进行维护。')), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('创建补货计划失败，请检查更新后重新创建')), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('发生错误。以下情报需要修改或者补充')), 1)
              ], 64)),
          (tableData.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(STable, {
                  ref: (_value, _refs) => {
                    _refs['STableRef'] = _value
                  },
                  columns: columns,
                  showPagination: false,
                  tableData: tableData.value,
                  "table-config": { height: 320 }
                }, {
                  prepOwnerConstraint: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_unref(labelMap)[row.prepOwnerConstraint] ?? '-'), 1)
                  ]),
                  labelOwnerConstraint: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_unref(labelMap)[row.labelOwnerConstraint] ?? '-'), 1)
                  ]),
                  amazonProductTitle: _withCtx(({ row }) => [
                    _createVNode(_component_el_tooltip, {
                      effect: "light",
                      placement: "top",
                      "popper-class": "tool-tip-no-border"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(row.amazonProductTitle), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(row.amazonProductTitle), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  errorCode: _withCtx(({ row }) => [
                    (row.errorCode > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('失败')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_18, "（" + _toDisplayString(_unref(errorMap)[row.errorCode]) + "）", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (row.errorCode === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('成功')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  prepCategory: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(__props.prepCategoryList.find(v => v.value === row.prepCategory)?.descJa ?? '-'), 1)
                  ]),
                  handleOption: _withCtx(({ row }) => [
                    (row.errorCode === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createTextVNode(_toDisplayString(_unref(t)('该amazon商品失效，请删除后重试')) + " ", 1),
                          _createElementVNode("a", {
                            style: {"color":"#0586FE"},
                            onClick: ($event: any) => (delGoods(row)),
                            class: "cursor-pt"
                          }, _toDisplayString(_unref(t)('删除商品')), 9, _hoisted_23)
                        ]))
                      : _createCommentVNode("", true),
                    (row.errorCode === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createTextVNode(_toDisplayString(_unref(t)('请先去amazon后台补充信息，并获取最新商品信息')) + " ", 1),
                          _createVNode(_component_el_button, {
                            type: "text",
                            onClick: ($event: any) => (updateGoods(row)),
                            loading: row.updateLoading,
                            class: "update-btn"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('更新')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "loading"])
                        ]))
                      : _createCommentVNode("", true),
                    (row.errorCode === 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createTextVNode(_toDisplayString(_unref(t)('请先在amazon后台确认信息是否正确，并获取最新商品信息')) + " ", 1),
                          _createVNode(_component_el_button, {
                            type: "text",
                            onClick: ($event: any) => (updateGoods(row)),
                            loading: row.updateLoading,
                            class: "update-btn"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('更新')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "loading"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["tableData"])
              ]))
            : _createCommentVNode("", true),
          (checkFinish.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "btn",
                  onClick: againCheck
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('重新创建国际发货单')), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible", "title", "hiddenClose"]),
    _createVNode(CommonDialog, {
      visible: createVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((createVisible).value = $event)),
      title: _unref(t)('提示'),
      width: 608,
      onCancel: closeModal,
      hiddenClose: true,
      closeOnClickModal: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          (!createSuccess.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_31))
            : (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34)),
          (!createSuccess.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createTextVNode(_toDisplayString(_unref(t)('商品校验通过，FBA补货计划创建中，请勿退出')) + " ", 1),
                _createElementVNode("span", _hoisted_36, _toDisplayString(loadingText.value), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_unref(t)('补货计划创建成功')), 1)),
          (!createSuccess.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_unref(t)('可能需要几分钟，请耐心等待！')), 1))
            : _createCommentVNode("", true),
          (createSuccess.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createVNode(_component_el_button, {
                  class: "btn",
                  onClick: closeModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push(_unref(useRtfix)('ReplenishmentList'))))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('去查看')), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}
}

})